// 微信工具类，集成登录、支付功能
export default {
  init: function ({ appid, redirectUri, state }) {
    this.appid = appid
    this.redirectUri = encodeURIComponent(redirectUri)
    this.state = state || 'defaultState'
    return this
  },
  author: function (isQuiet) {
    if (!this.redirectUri) throw new Error('缺失参数：redirectUri')
    // snsapi_base  静默
    // snsapi_userinfo  非静默
    let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${this.redirectUri}&response_type=code&scope=${isQuiet ? 'snsapi_base' : 'snsapi_userinfo'}&state=${this.state}#wechat_redirect&connect_redirect=1
=1`
    // console.error(url)
    window.location.href = url
  },
  getUrlParams: function () {
    let url = location.search
    // eslint-disable-next-line no-new-object
    let urlParams = new Object()
    if (url.indexOf('?') !== -1) {
      let str = url.substr(1); let strs = str.split('&')
      for (let i = 0; i < strs.length; i++) urlParams[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
    return urlParams
  },
  wexinPay (data, initConfig) {
    let { appId, timeStamp, nonceStr, packageValue, paySign, signType } = data
    return new Promise((resolve, reject) => {
      const jsApiCall = () => {
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': appId,
            'nonceStr': nonceStr,
            'package': packageValue,
            'signType': signType,
            'timeStamp': timeStamp,
            'paySign': paySign
          },
          function (res) {
            // eslint-disable-next-line no-undef
            WeixinJSBridge.log(res.err_msg)
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              resolve({ actionCode: 200 })
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
              resolve({ actionCode: 201 })
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject()
            }
          }
        )
      }
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', jsApiCall, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', jsApiCall)
          document.attachEvent('onWeixinJSBridgeReady', jsApiCall)
        }
      } else {
        jsApiCall()
      }
    })
  },
  config (data) {
    let { appId, timestamp, nonceStr, signature } = data
    wx.config({
      appId, // 必填，公众号的唯一标识
      timestamp, // 必填，生成签名的时间戳
      nonceStr, // 必填，生成签名的随机串
      signature, // 必填，签名
      jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateTimelineShareData','updateAppMessageShareData','wx-open-launch-weapp','chooseImage', 'previewImage'], // 必填，需要使用的JS接口列表
      openTagList: ["wx-open-launch-weapp"] // 跳转小程序时必填
    })
 
    wx.ready(function() {
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      console.log("wx ready");
    });

    wx.error(res => {
      console.error('wxerr: ', res)
    })
    return this
  },
  configShare (data = {
    title: 'Hello单身部落',
    desc: '优秀的单身汪都在这里!',
    link: location.origin + '/',
    imgUrl: location.origin + '/static/img/logo.png'
  }) {
    wx.ready(function () {
      if(wx.onMenuShareAppMessage) {
        wx.onMenuShareAppMessage(data)
      } else {
        wx.updateAppMessageShareData(data)
      }
      if (wx.onMenuShareTimeline) {
        wx.onMenuShareTimeline(data)
      } else {
        wx.updateTimelineShareData(data)
      }
      /* wx.updateAppMessageShareData({
        title: 'Hello部落', // 分享标题
        desc: '优秀的单身汪都在这里', // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'http://test.hellobuluo.com/favicon.ico' // 分享图标
      })
      wx.updateTimelineShareData({
        title: 'Hello部落', // 分享标题
        desc: '优秀的单身汪都在这里', // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'http://test.hellobuluo.com/favicon.ico' // 分享图标
      }) */
    })
  }
}
